var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-action-group"},[(_vm.label)?_c('span',{staticClass:"f-action-group__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"f-action-group__buttons"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }